"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._LOCALSTORAGE_KEY = void 0;
var crypt_1 = require("./crypt");
var event_1 = require("./event");
exports._LOCALSTORAGE_KEY = 'DIVE_WINDOW_STATE_MANAGER';
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.refreshStorageIfExists = function (cookieName, expires) {
        var value = Utils.getLocalStorage(cookieName);
        if (value) {
            this.setLocalStorage(cookieName, value, expires);
        }
    };
    Utils.processDiveParameters = function (allParameters, expires) {
        if (Utils.isClient()) {
            Object.entries(allParameters).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (key.indexOf(Utils.PARAMETER_PREFIX) !== -1) {
                    // If dive_cid was set by using SetDiveCid, must not be stepped on. The priority is SetDiveCid method
                    if (key !== Utils.DIVE_CID_KEY || (key === Utils.DIVE_CID_KEY && !Utils.getLocalStorage(Utils.DIVE_CID_KEY))) {
                        Utils.setLocalStorage(key, value, expires);
                    }
                }
            });
        }
    };
    Utils.refreshAllDiveStorage = function (expires) {
        var diveStorage = Utils.getAllDiveLocalStorage();
        Object.entries(diveStorage).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            Utils.setLocalStorage(key, value, expires);
        });
    };
    Utils.getAllDiveLocalStorage = function () {
        var storage = {};
        var length = localStorage.length;
        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key && key.indexOf(Utils.PARAMETER_PREFIX) !== -1 && key !== exports._LOCALSTORAGE_KEY) {
                var itemAsString = localStorage.getItem(key);
                if (itemAsString) {
                    var item = JSON.parse(itemAsString);
                    storage[key] = item.value;
                }
            }
        }
        return storage;
    };
    Utils.processQueryStringParams = function (sessionLifeTime) {
        if (Utils.isClient()) {
            var parameters = Utils.getQueryStringParams(window.location.search);
            var referrerQueryString = Utils.getReferrerQueryString();
            if (referrerQueryString) {
                parameters = Object.assign(Utils.getQueryStringParams(referrerQueryString), parameters);
            }
            Utils.processDiveParameters(parameters, sessionLifeTime);
        }
    };
    Utils.getReferrerQueryString = function () {
        var ret = null;
        if (Utils.isClient() && document.referrer) {
            var referrerArr = document.referrer.split("?");
            if (referrerArr.length > 1) {
                ret = referrerArr[1];
            }
        }
        return ret;
    };
    Utils.uuidv4 = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    Utils.getDeviceId = function () {
        var deviceId;
        if (!(deviceId = Utils.getLocalStorage(Utils.DEVICE_ID_KEY))) {
            Utils.setLocalStorage(Utils.DEVICE_ID_KEY, (deviceId = Utils.uuidv4()), 0);
        }
        return deviceId;
    };
    Utils.paramsToObject = function (params) {
        var _a;
        var arrParams = params.split("=");
        if (arrParams[0]) {
            if (arrParams[0].startsWith("dive_"))
                event_1.default.SetCustomHeaderParam(arrParams[0], arrParams[1]);
            return _a = {}, _a[arrParams[0]] = arrParams[1] || null, _a;
        }
        return {};
    };
    Utils.getQueryStringParams = function (locationSearch) {
        var search = locationSearch.replace("\?", "");
        var params = search.split("&");
        return params
            .map(this.paramsToObject)
            .reduce(function (obj, item) { return obj ? Object.assign(obj, item) : {}; });
    };
    Utils.digest = function (event, key) {
        return crypt_1.default.sha1_hmac(event, key);
    };
    Utils.firstSession = function () {
        if (!this.isClient())
            return true;
        return (!this.getLocalStorage(Utils.SESSION_ID_KEY));
    };
    Utils.setClientSessionIdStorage = function (sessionLifeTime) {
        var sessionId = Utils.getLocalStorage(Utils.SESSION_ID_KEY);
        if (!sessionId)
            sessionId = Utils.uuidv4();
        this.setLocalStorage(Utils.SESSION_ID_KEY, sessionId, sessionLifeTime);
    };
    Utils.removeClientSessionIdStorage = function () {
        this.removeLocalStorage(Utils.SESSION_ID_KEY);
    };
    Utils.removeDiveStorage = function () {
        this.removeLocalStorage(Utils.VIEWED_BEFORE_KEY);
        this.removeLocalStorage(Utils.SESSION_ID_KEY);
        this.removeLocalStorage(Utils.PLAYER_ID_KEY);
        this.removeLocalStorage(Utils.GAME_VER_KEY);
        this.removeLocalStorage(Utils.DIVE_CID_KEY);
    };
    Utils.refreshClientSessionId = function (sessionLifeTime) {
        var sessionId = Utils.getLocalStorage(Utils.SESSION_ID_KEY);
        if (!sessionId) {
            this.setClientSessionRestartedFromIdStorage();
            sessionId = Utils.uuidv4();
        }
        this.setLocalStorage(Utils.SESSION_ID_KEY, sessionId, sessionLifeTime);
    };
    Utils.setClientSessionRestartedFromIdStorage = function () {
        var sessionId = Utils.getLocalStorage(Utils.SESSION_ID_KEY);
        if (!sessionId)
            this.setLocalStorage(Utils.SESSION_RESTARTED_FROM_KEY, sessionId);
    };
    Utils.getClientSessionId = function () {
        return this.getLocalStorage(Utils.SESSION_ID_KEY);
    };
    Utils.getClientSessionRestartedFrom = function () {
        return this.getLocalStorage(Utils.SESSION_RESTARTED_FROM_KEY);
    };
    Utils.inArray = function (p1, p2) {
        return Array.isArray(p1) ? (p1.indexOf(p2) !== -1) : (Array.isArray(p2) ? (p2.indexOf(p1) !== -1) : false);
    };
    Utils.utcToLocal = function (date) {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    };
    Utils.setSettings = function (settings) {
        this.setLocalStorage(Utils.REMOTE_SETTINGS_KEY, JSON.stringify(settings));
    };
    Utils.getSettings = function () {
        var settings = this.getLocalStorage(Utils.REMOTE_SETTINGS_KEY);
        return settings ? JSON.parse(settings) : null;
    };
    Utils.getRemoteConfig = function () {
        var config = this.getLocalStorage(Utils.REMOTE_CONFIG_KEY);
        return config ? JSON.parse(config) : null;
    };
    Utils.setRemoteConfig = function (config) {
        this.setLocalStorage(Utils.REMOTE_CONFIG_KEY, JSON.stringify(config));
    };
    Utils.isIPV4Address = function (text) {
        return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(text);
    };
    Utils.PARAMETER_PREFIX = "dive_";
    Utils.SESSION_ID_KEY = "dive_csid";
    Utils.SESSION_RESTARTED_FROM_KEY = "dive_csrid";
    Utils.VIEWED_BEFORE_KEY = "dive_vbk";
    Utils.DIVE_CID_KEY = "dive_cid";
    Utils.DEVICE_ID_KEY = "DIVE_DEVICE_ID";
    Utils.TRACKING_STOPPED_KEY = "dive_tracking_stopped";
    Utils.PLAYER_ID_KEY = "dive_plid";
    Utils.GAME_VER_KEY = "dive_gmv";
    Utils.REMOTE_CONFIG_KEY = "dive_rc";
    Utils.REMOTE_SETTINGS_KEY = "dive_rs";
    Utils.prefabEvents = ["appLaunched", "beacon", "errorCreated", "screenViewed", "sdkStarted"];
    Utils.setLocalStorage = function (name, value, timeInSeconds) {
        if (!Utils.isClient())
            return;
        var item = {
            value: value,
            expires: timeInSeconds && Date.now() + timeInSeconds * 1000
        };
        localStorage.setItem(name, JSON.stringify(item));
    };
    Utils.getLocalStorage = function (name) {
        var storageItemAsString = localStorage.getItem(name);
        if (storageItemAsString) {
            var item = JSON.parse(storageItemAsString);
            if (item.expires && Date.now() > item.expires) {
                localStorage.removeItem(name);
                return null;
            }
            return item.value;
        }
        return null;
    };
    Utils.removeLocalStorage = function (name) {
        localStorage.removeItem(name);
    };
    Utils.toISO8601 = function (date) {
        return date.toISOString().split('.')[0] + "Z";
    };
    Utils.isClient = function () {
        return (typeof window !== 'undefined' || typeof document !== 'undefined');
    };
    return Utils;
}());
exports.default = Utils;
var WindowStateManager = /** @class */ (function () {
    function WindowStateManager(isNewWindowPromotedToMain, onWindowUpdated) {
        this.RECHECK_WINDOW_DELAY_MS = 100;
        this._initialized = false;
        this._unloaded = false;
        this._isNewWindowPromotedToMain = false;
        // this.resetWindows();
        this._onWindowUpdated = onWindowUpdated;
        this._isNewWindowPromotedToMain = isNewWindowPromotedToMain;
        this._windowId = Date.now().toString();
        this.bindUnload();
        this.determineWindowState.call(this);
        // console.log("NEW WINDOW ID", this._windowId);
        this._initialized = true;
        this._onWindowUpdated.call(this);
    }
    WindowStateManager.prototype.determineWindowState = function () {
        var self = this;
        var _previousState = this._isMainWindow;
        if (typeof localStorage !== "undefined") {
            this._windowArray = localStorage.getItem(exports._LOCALSTORAGE_KEY);
        }
        if (this._windowArray === null || this._windowArray === "NaN") {
            this._windowArray = [];
        }
        else {
            if (typeof localStorage !== "undefined") {
                this._windowArray = JSON.parse(this._windowArray);
            }
            else {
                this._windowArray = [];
            }
        }
        if (this._initialized) {
            if (this._windowArray.length <= 1 ||
                (this._isNewWindowPromotedToMain ? this._windowArray[this._windowArray.length - 1] : this._windowArray[0]) === this._windowId) {
                this._isMainWindow = true;
            }
            else {
                this._isMainWindow = false;
            }
        }
        else {
            if (this._windowArray.length === 0) {
                this._isMainWindow = true;
                this._windowArray[0] = this._windowId;
                if (typeof localStorage !== "undefined") {
                    localStorage.setItem(exports._LOCALSTORAGE_KEY, JSON.stringify(this._windowArray));
                }
            }
            else {
                this._isMainWindow = false;
                this._windowArray.push(this._windowId);
                if (typeof localStorage !== "undefined") {
                    localStorage.setItem(exports._LOCALSTORAGE_KEY, JSON.stringify(this._windowArray));
                }
            }
        }
        if (_previousState !== this._isMainWindow) {
            this._onWindowUpdated.call(this);
        }
        setTimeout(function () {
            self.determineWindowState.call(self);
        }, this.RECHECK_WINDOW_DELAY_MS);
    };
    WindowStateManager.prototype.removeWindow = function () {
        if (typeof localStorage !== "undefined") {
            var stored = localStorage.getItem(exports._LOCALSTORAGE_KEY);
            if (stored != null) {
                var __windowArray = JSON.parse(stored);
                // console.log("ARRAY BEFORE:", __windowArray);
                for (var i = 0, length = __windowArray.length; i < length; i++) {
                    if (__windowArray[i] === this._windowId) {
                        __windowArray.splice(i, 1);
                        if (__windowArray.length == 0) {
                            Utils.removeDiveStorage();
                        }
                        this._unloaded = true;
                        break;
                    }
                }
                // console.log("ARRAY AFTER:", __windowArray);
                localStorage.setItem(exports._LOCALSTORAGE_KEY, JSON.stringify(__windowArray));
            }
        }
    };
    WindowStateManager.prototype.bindUnload = function () {
        var self = this;
        if (typeof window !== "undefined") {
            window.addEventListener('beforeunload', function () {
                if (!self._unloaded) {
                    self.removeWindow();
                }
            });
        }
    };
    WindowStateManager.prototype.isMainWindow = function () {
        return this._isMainWindow;
    };
    ;
    WindowStateManager.prototype.resetWindows = function () {
        if (typeof localStorage !== "undefined") {
            localStorage.removeItem(exports._LOCALSTORAGE_KEY);
        }
    };
    ;
    return WindowStateManager;
}());
;
//@ts-ignore
var windowStateManager = new WindowStateManager(false, windowUpdated);
function windowUpdated() {
}
//# sourceMappingURL=utils.js.map